import React from 'react';
import { useLocation } from 'react-router-dom';
import DevSchemasTab from './dashboard/DevSchemasTab';

// /schemas            → landing (your schemas)
// /schemas/explore    → discover
// /schemas/create     → new-schema builder
// Rendered inside the portal shell (sidebar, no top bar).
export default function SchemasPage() {
  const { pathname } = useLocation();
  const routeView = pathname.startsWith('/schemas/explore') ? 'explore'
    : pathname.startsWith('/schemas/create') ? 'create'
    : 'landing';
  return (
    /* --fill: the page measures itself against the desk, not its content.
       .standalone-page is `min-height: 100vh`, and a percentage height cannot
       resolve against a min-height — so the library's own scroller would grow
       to the wall's full length instead of scrolling inside the desk. */
    <div className="standalone-page standalone-page--fill">
      <DevSchemasTab routed routeView={routeView} />
    </div>
  );
}
